import { Component, OnInit, Input, AfterViewInit, ElementRef } from "@angular/core";
import { UntypedFormBuilder } from "@angular/forms";
import { NzModalService, NzModalRef } from "ng-zorro-antd/modal";
import { NzMessageService } from "ng-zorro-antd/message";
import _ from "lodash";
import { TranslateService } from "@root/shared/service/translate.service";
import { HttpClient } from "@angular/common/http";
import { V4HousesModalSelectComponent } from "../../v4/houses-modal-select/houses-modal-select.component";

@Component({
  selector: "host-create-house-type",
  templateUrl: "./create-house-type.component.html",
  styleUrls: ["./create-house-type.component.scss"],
})
export class CreateHouseTypeComponent implements OnInit, AfterViewInit {
  // @Input() displaySuccessAlert = true;
  form = this.fb.group({
    name: null,
    createType: 0,
    houseNumber: 1,
    // 以上废弃
    title: null,
    house_count: null,
  });

  typeOfAddHouse: 0 | 1 = 0;
  selectedHouseList: Option[] = [];

  houseList = [];
  checking = false;

  constructor(
    private fb: UntypedFormBuilder,
    private modalService: NzModalService,
    private subject: NzModalRef,
    private messageService: NzMessageService,
    private translateService: TranslateService,
    private el: ElementRef,
    private http: HttpClient,
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      this.el.nativeElement.querySelector(".name-input").focus();
    }, 300);
  }

  save() {
    // this.checking = true;
    // if (!this.checkValid()) {
    //   return;
    // }
    const value = this.form.value;
    const params = { title: value.title };

    if (this.typeOfAddHouse === 0) {
      Object.assign(params, { house_count: value.house_count });
    } else {
      Object.assign(params, { house_ids: this.selectedHouseList.map((item) => item.value) });
    }

    this.http.post("/api/house_type/create", params).subscribe((res: any) => {
      // this.roomTypeService.createHouseType(params).subscribe((res) => {
      if (res.error_code === 0) {
        // 创建房型成功
        // const successText = this.translateService.t("success.create_house_type");
        // this.displaySuccessAlert && this.messageService.success(successText);
        this.subject.destroy("Ok");
      }
    });
  }

  checkValid() {
    const value = this.form.value;
    const name = value.name;
    if (!name || name === "") {
      return false;
    }
    if (value.createType === 1 && this.houseList.length === 0) {
      return false;
    }
    return true;
  }

  cancel() {
    this.subject.destroy();
  }

  // 添加房间
  onAddHouse() {
    const modal = this.modalService.create({
      nzTitle: this.translateService.syncGet("order.add_house"),
      nzContent: V4HousesModalSelectComponent,
      nzWidth: 725,
      nzFooter: null,
    });
    modal.afterClose.subscribe(({ data: rst }) => {
      this.selectedHouseList = rst;
      // if (res) {
      //   console.log(res);
      //   this.houseList = res;
      // }
    });
  }

  onRemoveSelectedHouse(index) {
    this.selectedHouseList.splice(index, 1);
  }

  // delete(house) {
  //   _.remove(this.houseList, { house_id: house.house_id });
  // }

  minus() {
    let num = _.get(this.form.value, "houseNumber");
    if (num <= 1) {
      this.messageService.warning("房间数不能小于1。");
    } else {
      this.form.patchValue({
        houseNumber: --num,
      });
    }
  }

  plus() {
    let num = _.get(this.form.value, "houseNumber");
    if (num >= 100) {
      this.messageService.warning("每次创建房间数量不能超过100。");
    } else {
      this.form.patchValue({
        houseNumber: ++num,
      });
    }
  }

  newHouseNumChange() {
    const num = _.get(this.form.value, "houseNumber");
    if (num < 1) {
      this.messageService.warning("房间数不能小于1。");
      this.form.patchValue({
        houseNumber: 1,
      });
    } else if (num > 100) {
      this.messageService.warning("每次创建房间数量不能超过100。");
      this.form.patchValue({
        houseNumber: 100,
      });
    }
  }
}
